import { IAnatomicalModel } from '../models';

export const isAnatomicalModelFeatureEnabled = (anatomicalModel: IAnatomicalModel, feature: string): boolean =>
  anatomicalModel?.features?.find((f) => f.name === feature) !== undefined;
